import React, { useState, useEffect } from "react";
import { FiEye, FiEdit, FiTrash2 } from "react-icons/fi";

import SearchButton from "../../../components/buttons/search/search-btn";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import CustomTable from "../../../components/table/table";
import "./view.css";
import CSVExport from "../../../components/csvExport";
import { get_resList_list, admin_resper_delete } from "../admin.api";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";
import moment from "moment";
import * as XLSX from "xlsx";
import ManageDomain from "./manage/manage";

const getStatusInfo = (status) => {
  const statusMap = {
    0: { label: "Pending", class: "pending", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg> },
    1: { label: "Submitted", class: "info", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg> },
    2: { label: "Approved", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> },
    3: { label: "SA Reverted", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> },
    4: { label: "Rejected", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg> },
    5: { label: "Reverted", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 8v4m0 4h.01"></path></svg> },
  };
  return statusMap[status] || { label: "Unknown", class: "secondary", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> };
};

export default function View(props) {
  const [data, setdata] = useState([]);
  const [view, setView] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [formData, setFormData] = useState({});

  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const onSearch = () => {
    //
  };
  const handleAdviserList = () => {
    setIsActive(true);
    get_resList_list(adminType).then((res) => {
      let tdata = res.data;
      let searchData = [];
      tdata.forEach((item, index) => {
        item["slno"] = index + 1;
        // searchData.push(item?.expert_manpower);
      });
      setdata(tdata);
      setIsActive(false);
    });
  };
  const handleAddNew = (row) => {
    let path = `/resource-add`;
    props.history.push(path);
  };

  const handleView = (data) => {
    let path = `/resource-view/${data.user_id}`;
    props.history.push(path);
  };

  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_resper_delete(data.id)
      .then((res) => {
        // setSnackMessage(res.message);
        setSnackMessage("Resource Personnel deleted successfully");
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleAdviserList();
    }
  };
  const handleDownload = () => { };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  useEffect(() => {
    handleAdviserList();
  }, []);
  async function fetchExportData() {
    const exportdata = [];
    data.forEach((item) => {
      exportdata.push({
        "Sl No": item.slno || "",
        Name: `${item?.title}. ${item?.first_name} ${item?.middle_name ? item?.middle_name : ""
          } ${item?.last_name}`,
        Email: item.email,
        ["Phone Number"]: item.phone_no,
        Date: item.created_at
          ? moment(item.created_at).format("DD-MMM-YYYY hh:mm A")
          : "--",
        Status:
          item.approval_status === 0
            ? "Pending"
            : item.approval_status === 1
              ? "Submitted"
              : item.approval_status === 2
                ? "Approved"
                : item.approval_status === 3
                  ? "SA Reverted"
                  : item.approval_status === 4
                    ? "Rejected"
                    : item.approval_status === 5
                      ? "Reverted"
                      : "",
      });
    });
    return exportdata;
  }
  const handleBulkEmail = () => {
    let path = `/bulk-email-resource-personnel`;
    props.history.push(path);
  };

  const downloadExcel = async () => {
    const exportData = await fetchExportData();
    if (!exportData.length) {
      setSnackMessage("No data to export");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Resource Personnel");

    XLSX.writeFile(workbook, "Resource_Personnel.xlsx");
  };

  const handleEdit = (data) => {
    setFormData(data);
    setView(false);
    setEdit(true);
  };
  const handleClose = () => {
    setEdit(false);
    setFormData({});
    handleAdviserList();
  };
  return (
    <div className="container-fluid mt-4">
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="card shadow-sm">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            <b>Resource Personnel</b>
          </h5>
          <div className="d-flex gap-2">
            {data?.length !== 0 && adminType !== 2 && (
              <button
                className="btn btn-primary btn-sm search-style border-0 text-white rounded"
                onClick={handleBulkEmail}
              >
                Bulk Email
              </button>
            )}
            <button
              className="btn btn-primary btn-sm search-style border-0 text-white rounded"
              onClick={downloadExcel}
            >
              Download Excel
            </button>
          </div>
        </div>

        <div className="card-body pt-3">
          <CustomTable
            {...props}
            columns={[
              { title: "Sl No", field: "slno", style: { width: "70px", maxWidth: "70px" } },
              {
                title: "Name",
                field: "first_name",
                render: (row) => (
                  <>
                    {row.first_name && row.first_name}{" "}
                    {row.middle_name && row.middle_name}{" "}
                    {row.last_name && row.last_name}
                  </>
                ),
              },
              { title: "Email", field: "email" },
              {
                title: "Photo",
                field: "file_upload",
                type: "resource-image",
              },
              { title: "Phone Number", field: "phone_no" },
              {
                title: "Status",
                field: "approval_status",
                render: (row) => {
                  const statusInfo = getStatusInfo(row.approval_status);
                  return (
                    <span className={`status-badge ${statusInfo.class}`}>
                      <span className="status-icon">{statusInfo.icon}</span>
                      <span className="status-label">{statusInfo.label}</span>
                    </span>
                  );
                },
              },
              {
                title: "Action",
                render: (row) => (
                  <div className="d-flex gap-1">
                    <button
                      className="btn btn-sm btn-outline-primary action-btn"
                      onClick={() => handleView(row)}
                      title="View"
                    >
                      <FiEye size={16} />
                    </button>
                    {adminType === 1 && (
                      <button
                        className="btn btn-sm btn-outline-secondary action-btn"
                        onClick={() => handleEdit(row)}
                        title="Edit"
                      >
                        <FiEdit size={16} />
                      </button>
                    )}
                    {adminType === 2 && (
                      <button
                        className="btn btn-sm btn-outline-danger action-btn"
                        onClick={() => handleDelete(row)}
                        title="Delete"
                      >
                        <FiTrash2 size={16} />
                      </button>
                    )}
                  </div>
                ),
              },
            ]}
            data={data}
          />
        </div>
      </div>
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Resource Personnel ?"
          data={activeData}
          message="Are you sure to delete this Resource Personnel?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
      {edit && (
        <ManageDomain
          open={edit}
          edit={edit}
          view={view}
          handleClose={handleClose}
          formData={formData}
        />
      )}
    </div>
  );
}
